import { useEffect } from 'react'

export function useScollToTop() {
	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])
}
